import { render, staticRenderFns } from "./ChooseGvd.modal.vue?vue&type=template&id=6c8c06dd"
import script from "./ChooseGvd.modal.vue?vue&type=script&lang=ts"
export * from "./ChooseGvd.modal.vue?vue&type=script&lang=ts"
import style0 from "./ChooseGvd.modal.vue?vue&type=style&index=0&id=6c8c06dd&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports